import { Header } from "../../../components/Landing/Header/haeder.view";
import { HeaderPp } from "../../../components/Landing/Header/haederPp";
import { Footer } from "../../../components/Landing/Footer";
import '../PeopleList.scss';
import segundaDesktop from "../../../assets/pp/BANNER-PAGINA-WEB-AGENDA-2026.jpeg";
import convocatoriaAgenda from "../../../assets/pp/convocatoriaAgenda.jpeg";
import bancoArtistas from "../../../assets/pp/bancoArtistas.jpeg";
import convocaAgenda from "../../../assets/pp/imagenconvocaagenda.jpeg";
import { CarouselCustom } from "../components/Carousel/CarouselCustom";

// style
import "../landing.style.scss";

export const PpAgenda = () => {
  return (
    <div>
      <Header />
      <HeaderPp />
      <CarouselCustom
        images={[
          { src: convocatoriaAgenda, alt: "Convocatoria Agenda PP cultural" },
          { src: segundaDesktop, alt: "Agenda PP" }
        ]}
      />
      <div className="container-fluid2 pt-5" style={{ marginTop: '0' }}>
        <div className="font-family-Montserrat text-center font-color-black" style={{ fontSize: 60 }}>
          <strong>
            <h1 className="mb-5" style={{ color: '#1e3a53' }}>
              AGENDA CULTURAL
            </h1>
          </strong>
          <h4 className="mb-3" style={{ textAlign: 'center', marginTop: '10px' }}>
            Es la programación de encuentros y eventos ciudadanos de arte y cultura para la promoción y proyección de las expresiones culturales y del talento artístico de cada comuna y corregimiento del Distrito, que permite y fomenta el acceso y disfrute por parte de los habitantes del respectivo territorio.
          </h4>
        </div>
      </div>
      <br />
      <div className="container-fluid2 pt-5">
        <div className="row justify-content-center">
          <div className="col-md-5 d-flex">
            <div className="card2-container">
              <div className="card2">
                <img
                  src={bancoArtistas}
                  alt="Random"
                  className="card2-image"
                />
                <div className="card2-content">
                  <h3 className="card2-title">Banco de Artistas PP</h3>
                  <p>
                    Se busca la proyección y la participación del sector cultural del Distrito, en la programación de la Agenda Cultural y Artística de PDL Y PP. El banco busca caracterizar y categorizar los artistas de acuerdo con sus experiencias y trayectorias en su quehacer artístico cultural y así lograr valorar económicamente sus presentaciones.
                  </p>
                  <div style={{ textAlign: "center", marginTop: "auto", paddingTop: "20px" }}>
                    <a
                      href="https://www.medellin.gov.co/estimuloscultura/verconvocatoria/1340"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn"
                      style={{
                        backgroundColor: "#1e3a53",
                        color: "white",
                        padding: "10px 20px",
                        borderRadius: "5px",
                        textDecoration: "none",
                        fontWeight: "bold",
                      }}
                    >
                      Ver convocatoria
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-5 d-flex">
            <div className="card2-container">
              <div className="card2">
                <img
                  src={convocaAgenda}
                  alt="Random"
                  className="card2-image"
                />
                <div className="card2-content">
                  <h3 className="card2-title">Agenda Cultural - PP</h3>
                  <p className="card2-description">
                    Definir la realización de eventos artísticos y culturales con impacto comunitario en los territorios que priorizaron recursos de Presupuesto Participativo, permitiendo que los proponentes seleccionados definan el lugar, fecha, temática, personal y artistas (80% de la parrilla) dentro de los marcos técnicos establecidos.
                  </p>
                  <div style={{ textAlign: "center", marginTop: "auto", paddingTop: "20px" }}>
                    <a
                      href="https://www.medellin.gov.co/estimuloscultura/verconvocatoria/1521"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn"
                      style={{
                        backgroundColor: "#1e3a53",
                        color: "white",
                        padding: "10px 20px",
                        borderRadius: "5px",
                        textDecoration: "none",
                        fontWeight: "bold",
                      }}
                    >
                      Ver convocatoria
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />
      <Footer />
    </div>
  );
};
